import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiRepository } from '../../../../shared/infrastructure/api.repository';
import { ConnectionRepositoryPort } from '../../domain/repositories/connection.repository.port';
import { Connection } from '../../domain/entities/connection.entity';
import { ConnectionApi, ConnectionMapper } from '../mappers/connection.mapper';

@Injectable({ providedIn: 'root' })
export class ConnectionRepository extends ApiRepository implements ConnectionRepositoryPort {
    private readonly baseUrl = '/entityConnections';

    getEntityConnections(): Observable<Connection[]> {
        return this.get<ConnectionApi[]>(`${this.baseUrl}/GetAll`).pipe(
            map(items => items.map(ConnectionMapper.toDomain))
        );
    }
}
